export default __webpack_public_path__ + "static/media/rectangle-1-break.e3df1263.webp";